import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_social-facebook",
  "use": "icon_social-facebook-usage",
  "viewBox": "0 0 9 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 17\" id=\"icon_social-facebook\"><path d=\"M1.891 3.198c0 .416.015 2.451.015 2.451H.114v2.608l1.777-.005.015 8.261h3.585V8.257l2.295-.005s.174-1.145.281-2.603H5.491s-.058-1.805-.058-2.089c0-.284.384-.666.764-.666H8.12V0H5.506C1.804 0 1.891 2.783 1.891 3.198z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol